import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { ROUTES } from '@app/constants'
import { useSubscriptionsFlag } from '@app/hooks/useSubscriptionsEnabled'

/**
 * Layout route for subscription screens — redirects to the feed when the tenant
 * has the `subscriptions` feature flag disabled. Renders nothing until the flag is known.
 */
const SubscriptionsRoute: FC = () => {
  const { loading, enabled } = useSubscriptionsFlag()

  if (loading) return null
  if (!enabled) return <Navigate to={ROUTES.feed.short} replace />

  return <Outlet />
}

export default SubscriptionsRoute
